import { render, staticRenderFns } from "./insertProductsOpeningBalance.vue?vue&type=template&id=2cd8c907"
import script from "./insertProductsOpeningBalance.vue?vue&type=script&lang=js"
export * from "./insertProductsOpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./insertProductsOpeningBalance.vue?vue&type=style&index=0&id=2cd8c907&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports